export type AnalayticsAppState = {
  analyticsIdentity?: string;
};

export const INITIAL_ANALAYTICS_APP_STATE: AnalayticsAppState = {};
